module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-wasou-accessories-12ab7e763ed0a5ecfcc695e487a5afa5.png";